import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFadeIn32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconFadeIn32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M17.365 1.788q.157 0 .302.039C24.791 2.62 30.33 8.66 30.33 15.996l-.005.368c-.181 7.153-5.632 12.995-12.615 13.795q-.165.05-.345.051a1.2 1.2 0 0 1-1.2-1.2V2.988a1.2 1.2 0 0 1 1.2-1.2m-4.837.7a1.2 1.2 0 0 1 1.2 1.2v24.62a1.2 1.2 0 0 1-2.4 0V3.687a1.2 1.2 0 0 1 1.2-1.2m6.037 25.1c5.352-1.146 9.365-5.9 9.365-11.592 0-5.694-4.013-10.448-9.365-11.594zM7.703 5.051a1.2 1.2 0 0 1 1.2 1.2V25.75a1.201 1.201 0 0 1-2.4 0V6.252a1.2 1.2 0 0 1 1.2-1.2m-4.83 4.352a1.2 1.2 0 0 1 1.2 1.2v10.787a1.201 1.201 0 0 1-2.401 0V10.604a1.2 1.2 0 0 1 1.2-1.2"
            />
        </svg>
    );
}
export default memo(IconFadeIn32);
